import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arrayMap' })
export class ArrayMapPipe implements PipeTransform {
    transform(input: any[], key: string, index: number = null): any {
        //console.log(input, key, index);
        return input.map(value => { return index != null ? value[key][index] : value[key] });
    }
}